import supportModule from '../../support.module';
import template from './supportFeedCreateComment.component.html';
import style from './supportFeedCreateComment.component.css';

export default supportModule.component('supportFeedCreateComment', {
    template,
    style,
    controller,
    bindings: {
        caseid: '<'
    }
});

function controller(
    accountProvider,
    asLoadingMask,
    asNotifier,
    imageHelper,
    liveChatService,
    supportViewCaseService,
    textResources,
    varHelper
) {
    var vm = this;

    vm.commentIsRequired = true;
    vm.commentMaxSize = 10000;
    vm.attachmentMaxSize = 2097152;
    vm.liveChatService = liveChatService;
    vm.supportViewCaseService = supportViewCaseService;

    vm.$onInit = () => {
        vm.cancel();

        accountProvider.getAccountUserInfo().then(data => {
            if (data && data.username) {
                vm.username = data.username;
            }
        });

        supportViewCaseService.getCommentConfig().then(
            data => {
                if (data.body) {
                    vm.commentIsRequired = data.body.isRequired;
                    if (
                        varHelper.isInteger(data.body.maxSize) &&
                        data.body.maxSize > 0
                    ) {
                        vm.commentMaxSize = data.body.maxSize;
                    }
                }
                if (
                    data.attachment &&
                    varHelper.isInteger(data.attachment.maxSize) &&
                    data.attachment.maxSize > 0
                ) {
                    vm.attachmentMaxSize = data.attachment.maxSize;
                }
            },
            () => {
                asNotifier.error(textResources.configurationNotLoaded);
            }
        );
    };

    vm.cancel = () => {
        vm.comment = null;
        vm.attachment = null;
        vm.resolveCase = null;
    };

    vm.submit = () => {
        if (vm.caseid) {
            asLoadingMask.show();
            supportViewCaseService
                .submitComment(
                    vm.caseid,
                    vm.comment,
                    vm.attachment,
                    vm.resolveCase
                )
                .then(
                    () => {
                        vm.cancel();
                        supportViewCaseService.loadCase(vm.caseid);
                    },
                    () => {
                        asNotifier.error(textResources.caseCommentSubmitFailed);
                    }
                )
                .finally(() => {
                    asLoadingMask.hide();
                });
        }
    };

    vm.isImage = () => {
        if (vm.attachment) {
            return imageHelper.hasImageExtension(vm.attachment.name);
        }
    };

    vm.initiateChat = () => {
        liveChatService.initiateChat();
    };
}



// WEBPACK FOOTER //
// ./modules/support/components/support-feed-create-comment/supportFeedCreateComment.component.js